import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';
import Diagram from '../../Components/Diagram';
import Turnout from '../../Components/Turnout';
import MandatesTrend from '../../Components/Senate/Mandates';
import SenateComposition from '../../Components/SenateComposition';
import { Title, Subtitle } from '../../Components/Header';
import labels from '../../Labels';
import Head2HeadList from '../../Components/Head2HeadList';
import SymbolTitle from '../../Symbols/Title';
import texts from '../../Labels';
import DistrictsOverview from '../../Components/DistrictsOverview'
import { getHasElectionFinished, getHasElectionStarted, getSubtitleByStatus, getHasFirstRoundStarted } from '../../Utils/Getters';
import styled from 'react-emotion';

const turnout = css`
	margin-bottom: 1rem;
	margin-top: 1.315rem;
`

const RoundTitle = styled.span`
	font-size: 2.25rem;
	font-weight: 500;
`

const getBaseDistrictWithCandidatesInfo = (districts) => districts.map(district => ({
	id: district.id,
	name: district.name,
	candidates: district.candidates.map(districtCandidate => ({
		name: districtCandidate.name,
		lastName: districtCandidate.lastName,
		id: districtCandidate.id,
		partyName: districtCandidate.party.name
	}))
}))


export default function Overview(props) {
	const electionHasStarted = getHasElectionStarted(props.meta)
	const electionHasFinished = getHasElectionFinished(props.meta)
	const hasFirstRoundStarted = getHasFirstRoundStarted(props.meta, props.roundIndex)


	return <>
		<Title.Input>Senátní volby {props.year}</Title.Input>
		<Subtitle.Input><RoundTitle>{labels.round[props.roundIndex]}. kolo</RoundTitle>{getSubtitleByStatus(electionHasStarted, electionHasFinished)}</Subtitle.Input>

		{electionHasStarted && <Turnout
			turnout={props.meta.turnout}
			count={props.meta.count}
			className={turnout}
		/>
		}
		{hasFirstRoundStarted ? <>
			<SymbolTitle>
				{texts.overviewListTitle[props.roundIndex]} {electionHasStarted && !electionHasFinished && '(průbežné výsledky)'}
			</SymbolTitle>
			<Head2HeadList
				items={props.districts}
				roundIndex={props.roundIndex}
				faces={props.faces}
				whenClosed="Všechny obvody"
				whenOpened="Méně obvodů"
			/>
		</> : <DistrictsOverview items={getBaseDistrictWithCandidatesInfo(props.districts)} whenOpened="Méně obvodů" whenClosed="Všechny obvody" />}

		{props.roundIndex === 0 && electionHasFinished && <Diagram
			title={labels.overviewRouteTitle[props.roundIndex]}
			items={props.proposingParties.length ? props.proposingParties : props.parties}
			getValue={item => item.total}
		/>
		}
		{props.roundIndex === 1 && <>
			{electionHasStarted && <MandatesTrend
				parties={props.proposingParties.length ? props.proposingParties : props.parties}
				actualMandates={props.actualMandates}
				groupBy={props.proposingParties.length ? 'nid' : 'vid'}
				final={electionHasFinished}
			/>}
			{electionHasFinished && <SenateComposition senators={props.senators} />}
		</>}

	</>;
}

Overview.propTypes = {
	elected: PropTypes.arrayOf(PropTypes.object).isRequired,
	finalists: PropTypes.arrayOf(PropTypes.object).isRequired,
	parties: PropTypes.arrayOf(PropTypes.object).isRequired,
	proposingParties: PropTypes.arrayOf(PropTypes.object).isRequired,
	meta: PropTypes.shape({
		turnout: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	}),
	roundIndex: PropTypes.oneOf([0, 1]).isRequired,
	senators: PropTypes.array.isRequired,
	actualMandates: PropTypes.array.isRequired
}
